import React from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import LockOutlined from '@material-ui/icons/LockOutlined';
import Email from '@material-ui/icons/Email';
import Typography from '@material-ui/core/Typography';
import grey from '@material-ui/core/colors/grey';
import FormControl from '@material-ui/core/FormControl';
import { Link } from 'react-router-dom';

import { Field, reduxForm } from 'redux-form'

const primaryGrey = grey[600]; // #F44336

const validate = values => {
  const errors = {}
  const requiredFields = [
    'email',
    'password'
  ]
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = 'Required'
    }
  })
  if (
    values.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
  ) {
    errors.email = 'Invalid email address'
  }

  return errors
}

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

const asyncValidate = (values /*, dispatch */) => {
  return sleep(1).then(() => {
    // simulate server latency
    if (['foo@foo.com', 'bar@bar.com'].includes(values.email)) {
      // eslint-disable-next-line no-throw-literal
      throw { email: 'Email already Exists' }
    }
  })
}

const renderTextField = ({
  input,
  label,
  meta: { touched, error },
  children,
  ...custom
}) => {
  return (
    <FormControl fullWidth margin='dense'>
      <TextField
        multiline={input.name === 'description'}
        rows={5}
        placeholder={label}
        error={touched && typeof error !== 'undefined'}
        {...input}
        {...custom}
      />
    </FormControl>
  )
}

class LogInForm extends React.PureComponent {

  render() {
    const { handleSubmit, pristine, submitting } = this.props;
    const forgotPasswordStyle = {
      textTransform: 'initial', 
      paddingRight: 0, 
      paddingTop: 0,
      fontWeight: 300,
      color: grey['500']
    }

    return (
      <form onSubmit={handleSubmit}>

        <Grid container spacing={8} alignItems="flex-end">
          <Grid item xs={2} md={4} align="right">
            <Email style={{color: primaryGrey}} />
          </Grid>
          <Grid item xs={9} md={5}>
              <div style={{paddingLeft: 5}}>
                <Field name="email" component={renderTextField} label='Email' />
              </div>
          </Grid>

        </Grid>

        <Grid container spacing={8} alignItems="flex-end">
          <Grid item xs={2} md={4} align="right">
            <LockOutlined style={{color: primaryGrey}} />
          </Grid>
          <Grid item xs={9} md={5}>
            <div style={{paddingLeft: 5}}>
              <Field name="password" component={renderTextField} label='Password' type="password" />
            </div>
          </Grid>
        </Grid>

        <Grid container spacing={8} alignItems="flex-end">
          <Grid item xs={11} md={7} align="right">
              <Typography paragraph variant='caption'>
                <Typography component={Link} to="/auth/password-reset" style={forgotPasswordStyle}>¿Has olvidado tu contraseña?</Typography>
              </Typography>
          </Grid>
        </Grid>

        <Grid container spacing={8} style={{marginTop: '1%'}}>
          <Grid item xs={12} align="center">
            <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={pristine || submitting}
                className={this.props.classes.buttonIndigo}>
              Entrar
            </Button>
          </Grid>
          <Grid item xs={12} align="center">
            <Typography paragraph className="grey-text" style={{marginTop: '2%'}}>
              Si no tienes una cuenta y quieres formar parte de nuestro panel <Typography component={Link} to="/register" className="green">regístrate</Typography>
            </Typography>
          </Grid>
        </Grid>

      </form>
    )
  }
}

LogInForm = reduxForm({
  form: 'login',
  validate,
  asyncValidate
})(LogInForm)

LogInForm = connect(state => ({
  auth: state.auth
}))(LogInForm)


export default LogInForm;



// WEBPACK FOOTER //
// ./src/modules/auth/forms/LogInForm.js